import { render, staticRenderFns } from "./fis.vue?vue&type=template&id=6a454514&"
import script from "./fis.vue?vue&type=script&lang=js&"
export * from "./fis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports